import React from "react";
import { Link } from "react-router-dom";
import { Quotation } from "features/Quotations/types/quotation.types";
import type { Product } from "features/Products/types/product.types";
import { getClientDisplayName } from "features/Clients/utils/clientDisplayName";

export function clientLine(record: Quotation): React.ReactNode {
  if (record.clientId != null && record.client) {
    const name = getClientDisplayName(record.client);
    return (
      <Link to={`/clients/${record.clientId}`} className="link fw-medium">
        {name !== "—" ? name : record.client.email || "—"}
      </Link>
    );
  }
  return "—";
}

export function productThumbUrl(product: Product | null | undefined): string {
  if (!product?.images?.length) return "";
  const first = product.images[0];
  if (typeof first !== "string") return "";
  return first;
}
